import React from "react";
import { ApplicationState } from "../store";
import { DamageFreeYearState, actions } from "../store/DamageFreeYear";
import { connect } from "react-redux";
import { FormHelperText, makeStyles, Theme } from "@material-ui/core";
import { useLocalValidation } from "../hooks/useLocalValidation";
import { RadioButtonGroupBase } from "./RadioButtonGroupBase";

type DamageFreeYearOptionsProps = DamageFreeYearState & {
  onChange: Function;
  forwardedRef: React.RefObject<HTMLDivElement>;
};

const useStyles = makeStyles((theme: Theme) => ({
  errorMessage: {
    color: theme.palette.error.main,
  },
}));

export const DamageFreeYearOptions: React.FC<DamageFreeYearOptionsProps> = (props: DamageFreeYearOptionsProps) => {
  const classes = useStyles();

  // Always call the hook, but use default/no-op params if not visible
  //this is due to a requirement that the hook must be called unconditionally
  //and it should not cause any side effects if the question is not visible
  useLocalValidation(
    props.questionVisible
      ? {
          fieldName: "damageFreeYear",
          state: !props.selected && props.showError ? 1 : 0,
          value: "",
          errorMessage: !props.selected ? props.requiredErrorMessage || "" : "",
        }
      : {
          fieldName: "damageFreeYear",
          state: 0,
          value: "",
          errorMessage: "",
        },
  );

  if (!props.questionVisible) {
    return <React.Fragment />;
  }

  return (
    <div ref={props.forwardedRef}>
      <RadioButtonGroupBase
        onChange={props.onChange}
        values={props.values.map(i => ({
          value: i.value.toString(),
          title: i.text,
        }))}
        id='damageFreeYear'
        selected={props.selected}
        label={{ title: props.title }}
        help={{
          title: props.description?.title,
          description: props.description?.text,
        }}
      />
      {props.showError && <FormHelperText className={classes.errorMessage}>{props.requiredErrorMessage}</FormHelperText>}
    </div>
  );
};

const stateToProps = (state: ApplicationState) => state.damageFreeYear;
const dispatcherToProps = {
  onChange: actions.damageFreeYearChanged,
};

export default connect(stateToProps, dispatcherToProps)(DamageFreeYearOptions);
